import { defineStore } from 'pinia'

export type Employer = { employer_id: number, employee_type: number, name: string, code: string };

export const useEmployerStore = defineStore('employer_store', () => {
    const current = ref<Employer | undefined>(undefined)
    const all = ref<Employer[]>([])

    return { current, all }
})

export type EmployerStoreType = ReturnType<typeof useEmployerStore>
